<template>
    <page-common :wrap-cls="['p-normal', 'xm-normal']" :on-line="onLine" :loading="loading" :is-exist="isExist" :reload="reload">
        <div class="m-hd">
            <h2 class="title f-taj">{{normal.title}}</h2>
            <div class="info f-cb">
                <span class="source">{{trim(normal.source)}}</span>
                <span class="dot">·</span>
                <span class="date" v-if="normal.pubTime">{{Date.parse(new Date(normal.pubTime.replace(/-/g, '/'))) | dateFormat('yyyy/MM/dd hh:mm:ss')}}</span>
            </div>
        </div>
        <div class="m-con f-taj">
            <div :class="{'m-text': true}" v-html="text"></div>
        </div>
    </page-common>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import Jt from 'common/util/jt';
import PageCommon from 'common/page/common';
import pageBaseMixin from 'common/mixin/page-base';
import pageDetailMixin from 'common/mixin/page-detail';
import 'common/style/p-normal.less';
import 'hw/style/p-normal.less';
const logo = require('common/image/icon59.png');

const Jt_B = Jt.base;
const Jt_D = Jt.dom;
let imgArr = [];

export default {
    mixins: [pageBaseMixin, pageDetailMixin],
    components: {
        PageCommon,
        // NewsRcmd,
    },
    data() {
        return {
            text: ''
        }
    },
    computed: {
    },
    watch: {
        '$route'() {
            const unfoldEl = this.$el && this.$el.querySelector('.m-unfold');
            const _this = this;
            if(unfoldEl) {
                Jt_D.css(unfoldEl, {display: 'none'});
            }
            this.init({id: this.$route.params.id, messageFrom: this.$route.query.messageFrom});
        },
        'normal'(newVal, oldVal) {
            this.formatText();
        }
    },
    mounted() {
        const _this = this;
        let index = 0;
        // 初始化图片懒加载器
        this.initLazyLoadImg();
        this.lazyLoadImg.options.success = function(el) {
            console.log(el)
            el.onclick = function() {
                try {
                    console.log(Jt_D.attr(this, 'index'), JSON.stringify(imgArr))
                    window.miui.openAtlasMode(Jt_D.attr(this, 'index'), JSON.stringify(imgArr))
                } catch (err) {
                    console.log('err', Jt_D.attr(this, 'index'), JSON.stringify(imgArr))
                }
            }
        }
        let timer = null;
        this.resizeHandle = () => {
            clearTimeout(timer);
            timer = setTimeout(this.onResize, 100);
        }
        window.addEventListener('resize', this.resizeHandle);
        this.text = this.getText();
    },
    beforeDestroy() {
        this.destroyLazyLoadImg();
        window.removeEventListener('resize', this.resizeHandle);
    },
    methods: {
        getText() {
            const $el = this.$el;
            // 来自资讯部的为normal.text;
            const normal = this.normal.miText || this.normal.text;
            let text = normal && normal.replace(/(\s+)?<br(\s+)?\/?>(\s+)?/gi,'');
            if(!$el || !text) {
                return;
            };
            if (this.normal.type === '3') {
                    text = [
                        '<div>',
                            '<div style="text-align: center">',
                                '<video controls>',
                                        '<source src=' + this.normal.videos[0].resources[0].url + '>',
                                '</video>',
                            '</div>',
                            text,
                        '</div>'
                    ].join('');
            }
            const tmpEl = document.createElement('div');
            tmpEl.innerHTML = text.replace(/<[^>]+>/ig, function (tag) {
                var tag;
                    if (tag.indexOf('img') === -1) {
                        // 不是img 标签处理规则
                        tag = tag.replace(/width/gi, '');
                        tag = tag.replace(/height/gi, '');
                        tag = tag.replace(/url/gi, '');
                    } else {
                        // img标签处理规则
                        tag = tag.replace(/width:/gi, '');
                        tag = tag.replace(/height:/gi, '');
                    }
                    tag = tag.replace(/letter-spacing/gi, '');
                    tag = tag.replace(/color/gi, '');
                    tag = tag.replace(/padding/gi, '');
                    tag = tag.replace(/margin/gi, '');
                if (tag.indexOf('<iframe') > -1) {
                    return '<p>'
                } else if (tag.indexOf('</iframe') > -1) {
                    return '</p>'
                } else if (tag.indexOf('<blockquote') > -1) {
                    return '<p>'
                } else if (tag.indexOf('</blockquote') > -1) {
                    return '</p>'
                } else {
                    return tag
                }
            });
            let childNodes = tmpEl.childNodes;
            while(childNodes.length === 1 && childNodes[0].nodeType === 1 && childNodes[0].childNodes.length) {
                childNodes = childNodes[0].childNodes;
            }
            const wrap = document.createElement('div');
            for(let i = 0, len = childNodes.length; i < len; i++) {
                if(childNodes[i].nodeType === 1) {
                    wrap.appendChild(childNodes[i].cloneNode(true));
                } else if(childNodes[i].nodeType === 3) {
                    const pEl = document.createElement('p');
                    pEl.appendChild(childNodes[i].cloneNode(true));
                    wrap.appendChild(pEl);
                }
            }
            const imgEls = wrap.getElementsByTagName('img');
            // 去除内容首末的空格 与 空标签(img, video, source例外)；
            this.domTrim(wrap);
            if(!imgEls.length) {
                return this.genFooterInfo(wrap.innerHTML);
            }
            const textEl = $el.querySelector('.m-text');
            const textW = textEl.offsetWidth;
            for(let i = 0, len = imgEls.length; i < len; i++) {
                const curImgEle = imgEls[i];
                const width = parseInt(curImgEle.dataset.width);
                const height = parseInt(curImgEle.dataset.height);
                const dataSrc = Jt_D.attr(curImgEle, 'data-src');
                // 图集准备数据
                dataSrc && imgArr.push(dataSrc);
                Jt_D.attr(curImgEle, {index: i})
                // 图集准备数据完毕
                Jt_D.attr(curImgEle, {
                    'data-src': dataSrc,
                    'src': require('common/image/dot.png')
                });
                Jt_D.css(curImgEle, {
                    'border-radius': '0.03rem'
                });
                if (width > 375) {
                    Jt_D.css(curImgEle, {
                        'width': '100%'
                    });
                } else if (width < 375) {
                    Jt_D.css(curImgEle, {
                        'width': width/100 + 'rem',
                        'height': height/100 + 'rem'
                    });
                }
                // 有的数据，img标签不是独生子女
                if (wrap === curImgEle.parentNode) {
                    var imgContainer = document.createElement('div');
                    imgContainer.appendChild(curImgEle.cloneNode(true));
                    wrap.replaceChild(imgContainer, curImgEle);
                }
                Jt_D.addClass(curImgEle.parentNode, 'pic-wrap');
            }
            const audioEls = wrap.getElementsByTagName('audio');
            for(let i = 0, len = audioEls.length; i < len; i++) {
                Jt_D.addClass(audioEls[i].parentNode, 'audio-wrap');
            }
            const videoEls = wrap.getElementsByTagName('video');
            for(let i = 0, len = videoEls.length; i < len; i++) {
                Jt_D.addClass(videoEls[i].parentNode, 'video-wrap');
            }
            // 去除内容首末的空格 与 空标签(img, video, source例外)；
            this.domTrim(wrap);
            return this.genFooterInfo(wrap.innerHTML);
        },
        genFooterInfo(domStr) {
            return '<div>' + domStr + '<div class="footer-info"><img src="' + logo + '" /><span>此内容由人民资讯提供</span></div></div>'
        },
        unfold() {
            const unfoldEl = this.$el.querySelector('.m-unfold');
            Jt_D.css(unfoldEl, {display: 'none'});
            const els = this.$el.querySelectorAll('.m-text .f-dn');
            for(let i = 0, len = els.length; i < els.length; i++) {
                Jt_D.removeClass(els[i], 'f-dn');
            }
        },
        formatText() {
            this.$nextTick(function() {
                this.lazyLoadImg.start();
                return;
            });
        },
        onResize() {
            if(!this.isExist) {
                return;
            }
            const textEl = this.$el.querySelector('.m-text');
            const imgEls = textEl.getElementsByTagName('img');
            const textW = textEl.offsetWidth;
            for(let i = 0, len = imgEls.length; i < len; i++) {
                const imgW = Jt_D.attr(imgEls[i], 'width');
                const imgH = Jt_D.attr(imgEls[i], 'height');
                if(!imgW || !imgH) {
                    continue;
                }
                const showW = imgW < textW ? imgW : textW;
                const showH = imgW < textW ? imgH : (textW * imgH / imgW);
                Jt_D.css(imgEls[i], {
                    'width': showW + 'px',
                    'height': showH + 'px'
                });
            }
        },
        getImgSize(img) {
            let imgW = Jt_D.attr(img, 'width');
            let imgH = Jt_D.attr(img, 'height');
            let style = img.style;
            if(!imgW && style.width) {
                imgW = style.width.replace('px', '');
            }
            if(!imgH && style.height) {
                imgH = style.height.replace('px', '');
            }
            return {
                width: imgW,
                height: imgH
            };
        },
        trim(text) {
            if (!text) {
                return '';
            }
            text = text.replace(/&nbsp;/ig, "");
            text = text.replace(/&ensp;/ig, "");
            text = text.replace(/&emsp;/ig, "");
            text = text.replace(/&thinsp;/ig, "");
            text = text.replace(/&zwnj;/ig, "");
            text = text.replace(/&zwj;/ig, "");
            return text == null ?
                "" :
                (text + "").replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        },
        // 去除内容首末的空格 与 空标签(img, video, source例外)；
        domTrim(wrap) {
            // 获取所有标签
            const wrapperNodes = wrap.getElementsByTagName('*');
            // 遍历所有标签
            for(var i = 0; i < wrapperNodes.length; i++) {
                // trim每个标签
                wrapperNodes[i].innerHTML = this.trim(wrapperNodes[i].innerHTML);
                // 
                if (!wrapperNodes[i].innerHTML
                    && wrapperNodes[i].tagName !== 'IMG'
                    && wrapperNodes[i].tagName !== 'VIDEO'
                    && wrapperNodes[i].tagName !== 'SOURCE') {
                    const temp = wrapperNodes[i].parentNode;
                    wrapperNodes[i].remove();
                    // 不能开启递归 dom操作容易引起性能问题。
                    // if (!this.trim(temp.innerHTML)) {
                    //     this.domTrim(wrap);
                    // }
                }
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/hw/page/normal.vue